import { findParentNodeOfType, findChildren, PlainExtension } from '@remirror/core';

export class TableNavigationExtension extends PlainExtension {
  constructor({ isEditable }) {
    super();
    this.isEditable = isEditable;
  }

  get name() {
    return 'tableNavigation';
  }

  createKeymap() {
    return {
      Tab: this.handleTabNavigation,
    };
  }

  handleTabNavigation = ({ state, dispatch }) => {
    const { selection } = state;

    const tableCell =
      findParentNodeOfType({ types: 'tableCell', selection }) ||
      findParentNodeOfType({ types: 'tableHeaderCell', selection });
    if (!tableCell) return false;

    const table = findParentNodeOfType({ types: 'table', selection });
    if (!table) return false;

    const cells = findChildren({
      node: table.node,
      predicate: (child) => ['tableHeaderCell', 'tableCell'].includes(child.node.type.name),
      descend: true,
    });
    const currentCellIndex = cells.findIndex((cell) => cell.pos + table.pos === tableCell.pos - 1);
    if (currentCellIndex === -1) return false;
    const nextCell = cells[(currentCellIndex + 1) % cells.length];
    if (dispatch) {
      const nextPos = table.pos + nextCell.pos;
      const tr = state.tr.setSelection(state.selection.constructor.near(state.doc.resolve(nextPos + 1)));
      dispatch(tr);
    }

    return true;
  };
}

export default TableNavigationExtension;
